import {
  FetchLatestResourcesPageableQuery,
  FetchLatestResourcesPageableQueryVariables,
  FetchLatestResourcesQuery,
  FetchLatestResourcesQueryVariables,
  ResourceEntity,
  ResourceQuery,
} from '@/graphql/generated/graphql';
import { initializeApollo } from '../lib/apollo-client';
import requestHandler from '../requestHandler';
import {
  QUERY_FETCH_LATEST_RESOURCES,
  QUERY_FETCH_RESOURCES_PAGEABLE,
  QUERY_RESOURCE,
} from '@/graphql/queries/knowledge-hub/resource';
import { getAuthors } from './utils';
import { Pagination } from '@/components/SeachTab';

export const fetchResource = async (slug: string) => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.query<ResourceQuery>({
      query: QUERY_RESOURCE,
      fetchPolicy: 'cache-first',
      variables: {
        slug: [slug],
      },
    }),
  );

  if (error) {
    console.error('Error fetching resource', error);
    return { resource: null };
  }

  if (!data?.resources?.data.length) {
    return { resource: null };
  }

  return {
    resource: data?.resources?.data[0] as ResourceEntity | null,
  };
};

export const fetchRelatedContent = async (slug: string) => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.query<FetchLatestResourcesQuery, FetchLatestResourcesQueryVariables>({
      query: QUERY_FETCH_LATEST_RESOURCES,
      fetchPolicy: 'cache-first',
      variables: {
        slug: [slug],
      },
    }),
  );

  if (error) {
    console.error('Error fetching resource', error);
    return { resource: null };
  }
  const relatedContent = data?.resources?.data.map((resource) => {
    return {
      title: resource.attributes?.title || '',
      description: resource.attributes?.briefDescription || '',
      author: getAuthors(resource as ResourceEntity),
      link: `/knowledge-hub/slug/${resource.attributes?.slug}`,
      type: resource.attributes?.resourceType?.data?.attributes?.type?.toString() || '',
      image: {
        url: resource.attributes?.cover?.data?.attributes?.url || '',
        alternativeText: resource.attributes?.cover?.data?.attributes?.alternativeText || '',
      },
    };
  });

  return {
    resources: relatedContent,
  };
};

export interface SearchTabFilters {
  kinds?: string[];
  search?: string;
  theme?: string;
  topic?: string;
}

export const fetchResourcePageable = async (page: number, filters: SearchTabFilters) => {
  const apolloClient = initializeApollo();

  const { kinds, search, theme, topic } = filters;

  const { data, error } = await requestHandler(
    apolloClient.query<FetchLatestResourcesPageableQuery, FetchLatestResourcesPageableQueryVariables>({
      query: QUERY_FETCH_RESOURCES_PAGEABLE,
      fetchPolicy: 'cache-first',
      variables: {
        page,
        kinds: kinds?.length === 0 ? undefined : kinds,
        search,
        theme: theme === 'null' ? undefined : theme,
        topic: topic === 'null' ? undefined : topic,
      },
    }),
  );

  if (error) {
    console.error('Error fetching resource', error);
    return { resources: [], pagination: {} as Pagination };
  }

  if (!data?.resources?.data.length) {
    return { resources: [], pagination: {} as Pagination };
  }

  return {
    resources: data?.resources?.data as ResourceEntity[],
    pagination: data?.resources?.meta.pagination as Pagination,
  };
};
